module.exports = kendo;